import { error, success } from '@redux-requests/core';
import {
  all,
  put,
  race,
  takeLatest,
} from 'redux-saga/effects';

import { SourceStatus } from 'shared/types/source';
import { VIEW_SOURCE_MODAL_NAME } from 'pages/common/ViewSourceModal';

import { openModal } from '../modal/actions';

import * as actions from './actions';
import { setSourceToView, fetchSourceStatus } from './actionCreators';
import { ViewSourceAction } from './types';

// Watcher sagas.
function* watchViewSourceAction() {
  yield takeLatest(actions.VIEW_SOURCE, viewSource);
}

// Worker sagas.
function* viewSource(action: ViewSourceAction) {
  const { source } = action.payload;

  yield put(fetchSourceStatus(source));

  const [successAction] = yield race([
    success(actions.FETCH_SOURCE_STATUS),
    error(actions.FETCH_SOURCE_STATUS),
  ]);

  // TODO: Temporary until we find the right endpoint to use to get the status of the source.
  const sourceToView = successAction ? { ...source, status: SourceStatus.PENDING } : source;

  yield put(setSourceToView(sourceToView));
  yield put(openModal(VIEW_SOURCE_MODAL_NAME));
}

export default function* SourceSagas() {
  yield all([
    watchViewSourceAction(),
  ]);
}
